import objectFitImages from 'object-fit-images';
import {throttle} from 'throttle-debounce';
import fitty from 'fitty';
import { attachFileUploadReveal } from './file';

require('select-woo');

/**
 * Providers content block (render-critical). The block renders ALL selected
 * providers so the cached HTML is identical for every visitor; keep 4 at
 * random client-side. Which items are removed is random; the kept ones stay in
 * DOM order (matches the old server-side array_rand). The CSS guard
 * (html.js .content-providers [data-random-pick]) hides the row until this
 * reveals it, so there's no flash of the full pool. Not AJAX — this is plain
 * render-time behavior, hence it lives in the route, not ajax-handlers.js.
 */
function pickRandomProviders() {
  var containers = document.querySelectorAll('.content-providers [data-random-pick]');
  Array.prototype.forEach.call(containers, function(container) {
    try {
      var n = parseInt(container.getAttribute('data-random-pick'), 10);
      var items = Array.prototype.slice.call(container.children);
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
      }
      if (n > 0 && items.length > n) {
        items.slice(n).forEach(function(el) {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
        });
      }
    } finally {
      container.style.visibility = 'visible';
    }
  });
  if (containers.length) {
    // Nudge Foundation's equalizer to re-measure the trimmed row.
    try {
      window.dispatchEvent(new Event('resize'));
    } catch (e) { /* older browsers: harmless to skip */ }
  }
}

export default {
  init() {
    // JavaScript to be fired on all pages
    attachFileUploadReveal();

    /* ------------------------------------------------------------------------
    // Providers content block — random featured pick (render-critical)
    // Runs first so the CSS visibility guard lifts ASAP. The failsafe reveal is
    // registered before any other init in case later code throws.
    // ------------------------------------------------------------------------ */
    setTimeout(function() {
      document.querySelectorAll('.content-providers [data-random-pick]').
        forEach(function(el) {
          el.style.visibility = 'visible';
        });
    }, 2000);
    pickRandomProviders();

    /* ------------------------------------------------------------------------
    // Object Fit
    // ------------------------------------------------------------------------ */
    objectFitImages();

    /* ------------------------------------------------------------------------
    // Hamburger Toggle
    // ------------------------------------------------------------------------ */

    $(document).on('opened.zf.offCanvas', '#off-canvas', function() {
      $('#hamburger').addClass('is-active');
    }).on('close.zf.offCanvas', '#off-canvas', function() {
      $('#hamburger').removeClass('is-active');
    });

    /* ------------------------------------------------------------------------
    // Search Trigger — opens overlay dialog, or focuses the inline search
    // form when there's no overlay on the current page (search results page).
    // ------------------------------------------------------------------------ */
    (function() {
      var triggers = document.querySelectorAll('.search-trigger a, a.search-trigger');
      if (!triggers.length) return;

      var overlay = document.getElementById('search-overlay');
      var hasOverlay = !!overlay;
      var lastFocused = null;

      // ---- Inline-form behavior (when no overlay exists on this page) ----

      function focusInlineForm(e) {
        var inlineInput = document.querySelector('.search-autocomplete');
        if (!inlineInput) return; // nothing to focus — let the link navigate
        e.preventDefault();
        inlineInput.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Focus after scroll settles (iOS requires a small delay).
        setTimeout(function() { inlineInput.focus({ preventScroll: true }); }, 300);
      }

      // ---- Overlay behavior (when overlay exists) ----

      function getFocusable() {
        return overlay.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
      }

      function positionBelowHeader() {
        var anchor = document.getElementById('search-form-anchor');
        var top = 0;
        if (anchor) {
          top = Math.max(0, anchor.getBoundingClientRect().top);
        }
        overlay.style.setProperty('--search-overlay-top', top + 'px');
      }

      function openOverlay(e) {
        if (e) e.preventDefault();

        // If the trigger was clicked from inside the mobile off-canvas menu,
        // close that menu first so the overlay isn't stacked on top of it.
        // Foundation's off-canvas API closes via jQuery plugin.
        if (window.jQuery && window.jQuery.fn.foundation) {
          var $offCanvas = window.jQuery('#off-canvas.is-open, #off-canvas-section-menu.is-open');
          if ($offCanvas.length) {
            $offCanvas.foundation('close');
          }
        }

        lastFocused = document.activeElement;
        overlay.removeAttribute('hidden');
        overlay.setAttribute('aria-hidden', 'false');
        positionBelowHeader();
        document.body.classList.add('search-overlay-open');
        triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'true'); });

        // Force reflow so the transition runs
        // eslint-disable-next-line no-unused-expressions
        overlay.offsetHeight;

        requestAnimationFrame(function() {
          overlay.classList.add('is-open');
          var input = overlay.querySelector('input[name="s"]');
          if (input) {
            input.focus();
            // Move cursor to end if pre-filled
            var val = input.value;
            input.value = '';
            input.value = val;
          }
        });
      }

      function closeOverlay() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('search-overlay-open');
        triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });

        setTimeout(function() {
          overlay.setAttribute('hidden', '');
        }, 260);

        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }

      // ---- Shared activation handler ----

      function activate(e) {
        if (hasOverlay) {
          openOverlay(e);
        } else {
          focusInlineForm(e);
        }
      }

      // ---- Trigger wiring (accessibility attrs + keyboard) ----

      triggers.forEach(function(trigger) {
        trigger.setAttribute('role', 'button');

        // Dialog-related ARIA only applies when an overlay exists on the page.
        // On the search results page the trigger just focuses the inline form,
        // so these attributes would be misleading.
        if (hasOverlay) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-controls', 'search-overlay');
          trigger.setAttribute('aria-haspopup', 'dialog');
        }

        trigger.addEventListener('click', activate);

        // Native <a> fires click on Enter only. role="button" implies Space
        // should also activate — add the handler explicitly.
        trigger.addEventListener('keydown', function(e) {
          if (e.key === ' ' || e.keyCode === 32) {
            e.preventDefault();
            activate(e);
          }
        });
      });

      if (!hasOverlay) return;

      // ---- Overlay-only listeners ----

      window.addEventListener('resize', function() {
        if (!overlay.hasAttribute('hidden')) positionBelowHeader();
      });

      overlay.addEventListener('click', function(e) {
        // Match target or any ancestor within the overlay — the <span> inside
        // the close button is often the actual click target.
        if (e.target.closest && e.target.closest('[data-search-close]')) {
          closeOverlay();
        }
      });

      document.addEventListener('keydown', function(e) {
        if (overlay.hasAttribute('hidden')) return;

        if (e.key === 'Escape' || e.keyCode === 27) {
          e.preventDefault();
          closeOverlay();
          return;
        }

        // Focus trap
        if (e.key === 'Tab' || e.keyCode === 9) {
          var focusable = getFocusable();
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    })();

    /* -------------------- ----------------------------------------------------
    // Balance Text
    // ------------------------------------------------------------------------ */
    // balanceText('.balance-text', {watch: true});

    /* ------------------------------------------------------------------------
    // Notices
    // ------------------------------------------------------------------------ */

    const notices = document.querySelectorAll('.callout.notice.hide');

    // Initially display any notices that have not been dismissed
    displayActiveNotices();

    notices.forEach(function(notice) {
      notice.querySelector('.close-button').
        addEventListener('click', function() {
          const noticeIdNum = notice.id.match(/\d+/)[0]; // Extract numerical ID
          storeDismissedNotice(noticeIdNum);
          notice.classList.add('hide'); // Ensure the notice is hidden
        });
    });

    function storeDismissedNotice(noticeIdNum) {
      let dismissedNotices = getDismissedNotices();
      if (!dismissedNotices.includes(noticeIdNum)) {
        dismissedNotices.push(noticeIdNum);
        const dismissedStr = JSON.stringify(dismissedNotices);
        document.cookie = 'dismissedNotices=' + dismissedStr +
          ';path=/;max-age=31536000'; // Store for 1 year
      }
    }

    function getDismissedNotices() {
      const value = '; ' + document.cookie;
      const parts = value.split('; dismissedNotices=');
      if (parts.length === 2) {
        try {
          return JSON.parse(parts.pop().split(';').shift());
        } catch (e) {
          return [];
        }
      }
      return [];
    }

    function displayActiveNotices() {
      let dismissedNotices = getDismissedNotices();
      notices.forEach(function(notice) {
        const noticeIdNum = notice.id.match(/\d+/)[0]; // Extract numerical ID
        if (!dismissedNotices.includes(noticeIdNum)) {
          notice.classList.remove('hide'); // Show active notices
        }
      });
    }

    /* ------------------------------------------------------------------------
    // Match Height
    // ------------------------------------------------------------------------ */
    $('.action-bar, .action-bar-placeholder').matchHeight({
      byRow: false,
    });

    fitty('.fit');

    /* ------------------------------------------------------------------------
    // Row Block Compensation
    // ------------------------------------------------------------------------ */

    $(window).resize(throttle(250, function() {
      $('.row-block-compensation').each(function() {

        var $columns = $(this).children('.column');
        var lastRowPosition = 0;
        var $lastRowColumns;
        var $otherColumns;

        $columns.each(function() {
          var position = $(this).position().top;
          if (position > lastRowPosition) {
            lastRowPosition = position;
          }
        });

        $lastRowColumns = $columns.filter(function() {
          return ($(this).position().top == lastRowPosition);
        });

        $otherColumns = $columns.filter(function() {
          return ($(this).position().top < lastRowPosition);
        });

        $lastRowColumns.removeClass('column-block');
        $otherColumns.addClass('column-block');
      });
    })).trigger('resize');

    /* ------------------------------------------------------------------------
    // Object Fit
    // ------------------------------------------------------------------------ */
    $('.testimonials').slick({
      autoplay: true,
      autoplaySpeed: 10000,
      dots: true,
      arrows: true,
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      slide: '.testimonial',
      appendDots: $('.slide-m-dots'),
      prevArrow: $('.slide-m-prev'),
      nextArrow: $('.slide-m-next'),
    });

    /* ------------------------------------------------------------------------
    // Modals
    // ------------------------------------------------------------------------ */

    $('.event-description a').modaal({
      type: 'image',
    });

    $('.popup-gallery').modaal({
      type: 'image',
    });

    $('.popup-video').modaal({
      type: 'video',
    });

    /* ------------------------------------------------------------------------
    // RCC Home Visit Participation — TOS modal + disabled-checkbox notice
    // ------------------------------------------------------------------------ */
    const rccHomeVisitTosDisabledMessage =
      'You cannot click this button without viewing the Terms and Conditions.';

    function clearRccHomeVisitTosDisabledNotice($field) {
      if (!$field || !$field.length) {
        return;
      }
      $field.find('.rcc-home-visit-tos-disabled-msg').remove();
    }

    function showRccHomeVisitTosDisabledNotice($field) {
      if (!$field || !$field.length) {
        return;
      }

      clearRccHomeVisitTosDisabledNotice($field);

      const $message = $('<div/>', {
        'class':
          'gfield_description validation_message gfield_validation_message ' +
          'rcc-home-visit-tos-disabled-msg',
        role: 'alert',
        text: rccHomeVisitTosDisabledMessage,
      });

      const $inputContainer = $field.find('.gptos_input_container');
      if ($inputContainer.length) {
        $inputContainer.after($message);
      } else {
        $field.append($message);
      }
    }

    function getRccHomeVisitTosModaalOptions() {
      return {
        custom_class: 'rcc-home-visit-tos-modaal',
        after_open: function() {
          const $terms = $(
            '.modaal-wrapper.rcc-home-visit-tos-modaal .gptos_terms_container'
          );
          $terms.off('scroll.rccHomeVisitTos').
            on('scroll.rccHomeVisitTos', function() {
              const $field = $(
                'form.rcc-home-visit-participation-form .gfield--type-tos'
              ).first();
              const $checkbox = $field.find('input[type="checkbox"]').first();
              if ($checkbox.length && !$checkbox.prop('disabled')) {
                clearRccHomeVisitTosDisabledNotice($field);
              }
            });
        },
      };
    }

    $('.popup-inline').each(function() {
      const $link = $(this);
      const options = $link.closest('.rcc-home-visit-tos-trigger').length
        ? getRccHomeVisitTosModaalOptions()
        : {};
      $link.modaal(options);
    });

    let modal_gform_error = $('.gform_validation_error').
      closest('.modal-outer-container');
    console.log('modal_gform_error', modal_gform_error);
    if (modal_gform_error.length) {
      console.log('attempting to open modal');
      requestAnimationFrame(() => {
        console.log('requestAnimationFrame');
        $('a[href=#' + modal_gform_error.prop('id') + ']').
          first().
          trigger('click');
      });
    }

    // Disabled checkboxes swallow clicks; pointer-events:none (CSS) lets the
    // container receive the click. Handle both container and choice wrappers.
    $(document).on(
      'click',
      'form.rcc-home-visit-participation-form .gfield--type-tos .gptos_input_container, ' +
      'form.rcc-home-visit-participation-form .gfield--type-tos .gchoice',
      function(event) {
        const $field = $(this).closest('.gfield--type-tos');
        const $checkbox = $field.find('input[type="checkbox"]').first();

        if (!$checkbox.length || !$checkbox.prop('disabled')) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        showRccHomeVisitTosDisabledNotice($field);
        $field.find('.rcc-home-visit-tos-trigger a.popup-inline').
          first().
          trigger('click');
      }
    );

    $(document).on(
      'change',
      'form.rcc-home-visit-participation-form .gfield--type-tos input[type="checkbox"]',
      function() {
        clearRccHomeVisitTosDisabledNotice($(this).closest('.gfield--type-tos'));
      }
    );

    $(document).on('gform_post_render', function(event, formId) {
      $('#gform_wrapper_' + formId + ' .rcc-home-visit-tos-trigger a.popup-inline').
        modaal(getRccHomeVisitTosModaalOptions());

      const $tosErrorTrigger = $(
        '#gform_wrapper_' + formId +
        ' .gfield--type-tos.gfield_error .rcc-home-visit-tos-trigger a.popup-inline'
      ).first();

      if ($tosErrorTrigger.length) {
        requestAnimationFrame(() => {
          $tosErrorTrigger.trigger('click');
        });
      }
    });

    /* ------------------------------------------------------------------------
    // Event Tracking
    // ------------------------------------------------------------------------ */

    function gaSendEvent(category, action, label) {
      console.log({
        'category': category,
        'action': action,
        'label': label,
      });

      /*eslint-disable */

      if ('ga' in window) {
        var tracker = ga.getAll()[0];
        if (tracker) {
          tracker.send('event', category, action, label);
        }
      } else {
        console.log(
          'Event tracking is not yet activated. Make sure Google Analytics is setup correctly.');
      }

      /*eslint-enable */
    }

    $(document).on('click', 'a', function() {

      var link = this,
        $link = $(this);

      /* ------------------------------------------------------------------------
      // Outbound Links
      // ------------------------------------------------------------------------*/
      if (link.hostname && (link.hostname !== location.hostname) &&
        !$link.hasClass('popup-video')) {
        gaSendEvent('Outbound Links', 'Click', link.href);
      }

      /* ------------------------------------------------------------------------
      // YouTube Links
      // ------------------------------------------------------------------------*/
      if ($link.hasClass('popup-video')) {
        gaSendEvent('Videos', 'Play', link.href);
      }

      /* ------------------------------------------------------------------------
      // Link Event Tracking
      // ------------------------------------------------------------------------*/
      if ($link.is('[data-event-tracking-label]')) {
        gaSendEvent($link.attr('data-event-tracking-category'),
          $link.attr('data-event-tracking-label'), link.href);
      }

      /* ------------------------------------------------------------------------
      // Mail Links
      // ------------------------------------------------------------------------*/
      if ($link.is('[href^="mailto:"]')) {
        gaSendEvent('Mails', 'Click', link.href.replace(/mailto:/ig, ''));
      }

      /* ------------------------------------------------------------------------
      // Telephone Links
      // ------------------------------------------------------------------------*/
      if ($link.is('[href^="tel:"]')) {
        gaSendEvent('Phone Links', 'Click', link.href.replace(/tel:/ig, ''));
      }

      /* ------------------------------------------------------------------------
      // Share Links
      // ------------------------------------------------------------------------*/
      if ($link.hasClass('addtoany_share')) {
        gaSendEvent('Share Links', 'Click', document.title);
      }

      /* ------------------------------------------------------------------------
      // Document Links
      // ------------------------------------------------------------------------*/
      if ($link.is(
        '[href$=".pdf"],[href$=".doc"],[href$=".docx"],[href$="xls"],[href$="xlsx"]')) {
        var label = (link.hostname && link.hostname !== location.hostname)
          ? link.href
          : ('/' + link.pathname).replace('//', '/');
        var ext = link.href.split('.').pop().toUpperCase();
        gaSendEvent('Downloads', ext, label);
      }

    });

    /* ------------------------------------------------------------------------
    // Select Woo
    // ------------------------------------------------------------------------ */
    $('.select-woo').selectWoo();

    /* ------------------------------------------------------------------------
    // Providers
    // ------------------------------------------------------------------------ */

    $(document).on('click', '[data-provider-name]', function() {
      console.log($(this).attr('data-provider-name'));
      $('.populate-provider-name input').
        val($(this).attr('data-provider-name'));
    });

    $(document).on('click', '[data-provider-location]', function() {
      console.log($(this).attr('data-provider-location'));
      $('.populate-provider-location input').
        val($(this).attr('data-provider-location'));
    });

    $(document).on('click', '[data-provider-id]', function() {
      console.log($(this).attr('data-provider-id'));
      $('.populate-provider-id input').
        val($(this).attr('data-provider-id')).
        change();
    });

    $(document).on('click', '[data-location-id]', function() {
      console.log($(this).attr('data-location-id'));
      $('.populate-location-id input').val($(this).attr('data-location-id'));
    });

    $(document).on('click', '[data-dsp]', function() {
      console.log($(this).attr('data-dsp'));
      $('.populate-dsp input').val($(this).attr('data-dsp'));
    });

    function show_hide_rx_upload() {
      let service = $('#input_6_15');
      let rx = $('#input_6_33');
      let upload_container = $('#field_6_38');
      let upload = $('#input_6_38');

      if (service.val() === 'Imaging' && rx.val() == 'Yes') {
        upload_container.show();
        upload.prop('disabled', false);
      } else {
        upload_container.hide();
        upload.prop('disabled', true);
      }
    }

    $(document).on('change', '#input_6_15', show_hide_rx_upload);

    $(document).on('change', '#input_6_33', show_hide_rx_upload);

    /* ------------------------------------------------------------------------
    // Input Masking
    // ------------------------------------------------------------------------ */
    let masks = $('.input-masking input[type=text]');
    if (masks.length) {
      $(document).ready(function() {
        setTimeout(function() {
          masks.each(function() {
            if ($(this).val()) {
              let mask = $(this);
              setTimeout(function() {
                mask.prev().html('<i>' + mask.val() + '</i>');
              }, 500);
            }
          });
        }, 300);
      });
    }

    /* ------------------------------------------------------------------------
    // DECHO Sticky Footer Fix
    // ------------------------------------------------------------------------ */
    $(document).ready(function() {
      var dechos = $('.DECHO');
      var placeholder = $('.action-bar-placeholder');
      if (dechos.length && placeholder.length) {
        dechos.last().after(placeholder);
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
